import axios from 'axios'

export const getPageTargetingDataReq = ({ accountID, channelID, productID }) =>
  axios.get(`/targetingControl/${accountID}/${channelID}/${productID}`)

export const patchPageTargetingDataReq = ({ accountID, channelID, productID, data }) =>
  axios.patch(`/targetingControl/${accountID}/${channelID}/${productID}`, data)
